// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Aubp","footer":"ModalCreateQualiphyProcedure_footer__1nZK0","additionData":"ModalCreateQualiphyProcedure_additionData__2LHuK"};